import axios from "axios";
import { baseURL } from "../config/api";

export const post_AppointmentTireReservation = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}appointmentTireReservations?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_AppointmentWheelReservation = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}appointmentWheelReservations?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_AppointmentTireReservation = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}appointmentTireReservations?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_AppointmentWheelReservation = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}appointmentWheelReservations?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_AppointmentTirePosition = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}appointmentTireServicePositions?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const getPositions = (attributeName: string) => {
    return getFetch(`statuses/GetExpressStatusesByAttributeName/${attributeName}`)
}

export const getInventoryByTireFitment = (tireFitmentId: number, isCommercial: boolean, locationId: number) => {
    return getFetch(`inventories/GetInventoryByTireFitment/${locationId},${tireFitmentId},${isCommercial}`)
}

export const getInventoryByWheelFitment = (wheelFitmentId: number, isCommercial: boolean, locationId: number) => {
    return getFetch(`inventories/GetWheelInventoryByTireFitment/${locationId},${wheelFitmentId},${isCommercial}`)
}

export const delete_AppointmentTireReservation = (id: number, userId: number) => {
    return axios({
        url: `${baseURL}appointmentTireReservations?id=${id}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

export const delete_AppointmentWheelReservation = (id: number, userId: number) => {
    return axios({
        url: `${baseURL}appointmentWheelReservations?id=${id}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

export const delete_AppointmentTirePosition = (id: number, userId: number) => {
    return axios({
        url: `${baseURL}appointmentTireServicePositions?id=${id}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}